import { render } from "./Reservas.vue?vue&type=template&id=090b3a92&scoped=true"
import script from "./Reservas.vue?vue&type=script&lang=js"
export * from "./Reservas.vue?vue&type=script&lang=js"

import "./Reservas.vue?vue&type=style&index=0&id=090b3a92&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090b3a92"]])

export default __exports__